import React, { useEffect, useState } from "react";
import AppNavbar from "../../components/common/AppNavbar";
import { fetchNewsByCategory } from "../../services/api";
import Loading from "../../components/common/Loading";
import NewsSection from "../../components/home/NewsSection";
import ImmCountry from "../../components/Immigration/Immigation";
import ImmNewsSection from "../../components/Immigration/ImmNewsSection";
import ImmigrationHub2026 from "./ImmNews/ImmNews";
import { Image } from "react-bootstrap";
import { Helmet } from "react-helmet";

function Immigration() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      const data = await fetchNewsByCategory("immigration");
      setNews(data);
      setLoading(false);
    }
    load();
  }, []);

  if (loading) return <Loading />;

  return (
    <>
      <Helmet>
        <title>
          Immigration News India | Visa, Study Abroad, PR & Jobs Updates –
          BharatAbroad
        </title>
        <meta
          name="title"
          content="Immigration News India | Visa, Study Abroad, PR & Jobs Updates – BharatAbroad"
        />
        <meta
          name="description"
          content="Explore the latest immigration updates, visa news, study abroad guidance, PR visa updates, work opportunities, and country-wise immigration rules on BharatAbroad."
        />
        <meta
          name="keywords"
          content="Indians in USA news, Indians in UK latest news, Indian community Canada, Indians in Gulf countries, Indian diaspora news, Pravasi Bharatiya news, H1B visa Indians, OCI card news, Indian passport renewal abroad, Indian consulate news, India visa on arrival, NRI latest news India today, Indian diaspora investment news, Indians abroad latest updates, Indian students abroad news, Study in USA from India news, Visa rules for Indians 2026, Green card news for Indians, UK immigration rules Indians, Canada PR news Indians, Australia visa Indians updates, Gulf job news for Indians, Indian workers UAE news, Remittance to India from USA, NRI banking India updates, Overseas Indian voting rights, Dual citizenship India debate, Indians in Europe news, Indians in Singapore news, Indians in New Zealand updates, Indians in South Africa news, Indian expats Middle East news, Indian professionals abroad news, Indian entrepreneurs overseas news, NRI property disputes India, NRI inheritance laws India, NRI legal issues India updates, Indian embassy advisory news, Travel advisories for Indians abroad, Indian student visa rejection news, International student policy changes, Scholarships for Indian students abroad, Work permit rules Indians abroad, Post study work visa news, Skilled migration programs Indians, Express entry Canada Indians news, US immigration backlog Indians, H1B lottery updates Indians, OPT visa rules Indians USA, UK student visa Indians updates, UK post study work visa Indians, Australia PR points system Indians, Gulf labour laws Indians, Saudi Arabia job rules Indians, Qatar job market Indians, UAE visa reforms Indians, Dubai residency visa Indians, Golden visa UAE Indians, NRI retirement abroad planning, Returning to India NRI rules, Reverse migration Indians news, Indian origin politicians abroad, Indian CEOs global companies, NRI marriage legal rules India, NRI taxation abroad vs India, FATCA rules India NRI, Foreign income tax India NRI, Global banking for NRIs, International money transfer India news, Forex rules for NRIs India, UPI for NRIs updates, NRE NRO account news, FCNR account interest rates India, RBI guidelines for NRIs latest, Pravasi Bharatiya Divas updates, BharatAbroad immigration, BharatAbroad visa news, BharatAbroad NRI updates"
        />

        {/* Technical */}
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta charSet="UTF-8" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Immigration News India | USA, Canada, Australia, Europe & Singapore Visa Updates – BharatAbroad"
        />
        <meta
          property="og:description"
          content="Get the latest immigration news, visa updates, study abroad guidance, PR rules, NRI news, work permits, and opportunities for Indians in the USA, Canada, Australia, Europe, Singapore, and worldwide on BharatAbroad."
        />
        <meta property="og:site_name" content="BharatAbroad" />
        <meta
          property="og:url"
          content="https://www.bharatabroad.com/immigration"
        />
        <meta
          property="og:image"
          content="https://ayg.s3.us-east-2.amazonaws.com/bharatabroad.com-immigration.png"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Latest Immigration & Visa News for Indians Worldwide – BharatAbroad"
        />
        <meta
          name="twitter:description"
          content="Explore the latest USA, Canada, Australia, Europe, Singapore, and global immigration updates including visas, PR, study abroad, jobs, NRI news, and travel rules for Indians on BharatAbroad."
        />
        <meta
          name="twitter:image"
          content="https://ayg.s3.us-east-2.amazonaws.com/bharatabroad.com-immigration.png"
        />
        <meta name="twitter:site" content="@BharatAbroad" />

        {/* Canonical */}
        <link rel="canonical" href="https://www.bharatabroad.com/immigration" />
      </Helmet>
      <AppNavbar />
      <div style={{ padding: "20px" }}>
        <div id="container">
          {/* <NewsSection
            title="Immigration News"
            articles={news}
            category="immigration"
          /> */}
          <ImmigrationHub2026 />
          <div className="text-center p-2">
            <small>Advertisement</small>
            <Image
              className="mx-auto d-block"
              src="https://ayg.s3.us-east-2.amazonaws.com/bharat/IMG-20240821-WA0057.jpg"
              fluid
            />
          </div>
          <ImmCountry />
        </div>
      </div>
    </>
  );
}

export default Immigration;
